/**
 * TypeScript (rightly) complains that the value from the html template here is of type Event, not CustomEvent,
 * so let's fix that complaint:
 * 
 * See: https://forum.ionicframework.com/t/argument-of-type-event-is-not-assignable-to-parameter-of-type-customevent-any/206639/7
 * and https://stackoverflow.com/questions/47166369/argument-of-type-e-customevent-void-is-not-assignable-to-parameter-of-ty
 */
export function isCustomEvent<T extends CustomEvent>(event: Event): event is T {
  return 'detail' in event;
}

export function sleep(time: number): Promise<void> {
  return new Promise((resolve,reject) => {
    setTimeout(()=>resolve(),time)
  })
}